<template>
  <div class="container" style="background-color: #f0f2f5">
    <div class="mallView">
      <div class="mall-swiper">
        <van-swipe height="210" autoplay="3000" @change="onChange">
          <van-swipe-item v-for="(pic, index) in banner" :key="index">
            <img :src="pic" alt="">
          </van-swipe-item>
          <div class="custom-indicator" slot="indicator">
            <span class="currentDot">{{ current + 1 }}</span>/{{banner.length}}
          </div>
        </van-swipe>
      </div>
      <div class="mall_view_list">
        <div class="goods_view_title">{{product.productname}}</div>
        <div class="goods_view_des">{{product.summary}}</div>
        <div class="goods_view_price">¥{{product.price}}</div>
        <div class="goods_view_courier">
          <div>发货：{{product.shippingcity}}</div>
          <div>销量：{{product.sellnum}}</div>
          <div>库存：{{product.banlancenum}}</div>
        </div>
      </div>
      <div class="mall_view_list">
        <div class="mall_flex_box num_freight">
          <div class="flex_box_label">数量：</div>
          <div class="flex_box_val goods_num_block">
            <div class="goods_buy_num">{{num}}</div>
            <van-stepper class="goods_num_step" v-model="num" :min="product.banlancenum > 0 ? 1 : 0" :max="product.banlancenum" integer />
          </div>
        </div>
        <div class="mall_flex_box num_freight">
          <div class="flex_box_label">运费：</div>
          <div class="flex_box_val">{{product.expressfee ? '￥' + product.expressfee : '免运费'}}</div>
        </div>
      </div>
      <div class="mall_view_list title_list">
        <div class="mall-item_title">书籍参数</div>
        <div class="specification" v-html="product.specification"></div>
      </div>
      <div class="mall_view_list title_list">
        <div class="mall-item_title">书籍详情</div>
        <div class="proCon" v-html="product.content"></div>
      </div>
      <div class="mall_footer">
        <!-- <van-button type="default">联系客服</van-button> -->
        <a class="service" href="tel://020-83341279">联系客服</a>
        <van-button class="goods-buy-btn" type="default" @click="pay" :disabled="num === 0">立即购买</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  export default {
    name: 'mallIndex',
    data () {
      return {
        current: 0,
        num: 1,
        product: {},
        banner: []
      }
    },
    created () {
      this.$toast.allowMultiple()
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true
      })
      this.$fetch.get(API.PRODUCTDETAIL, {
        id: this.$route.query.id
      }).then(response => {
        // console.log(response)
        load.clear()
        if (response.status !== 200) {
          var msg = response.message? response.message : '商品详情获取失败，请刷新！'
          this.$toast.fail(msg)
          return
        }
        this.product = response.data
        this.banner = response.data.gallery.split(',')
        this.num = response.data.banlancenum > 0 ? 1 : 0
        if (u.indexOf('MicroMessenger') > -1) {
          this.$fetch.get(API.GETWECHATINVOKESIGN, {
            url: window.location.href
          }).then(res => {
            let data = res.data
            wx.config({
              debug: false,
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
            wx.ready(function(){
              wx.updateAppMessageShareData({
                title: response.data.productname,
                desc: response.data.summary,
                link: window.location.href,
                imgUrl: response.data.logo,
                success: function() {
                  console.log('分享成功')
                }
              })
              wx.updateTimelineShareData({
                title: response.data.productname,
                link: window.location.href,
                imgUrl: response.data.logo,
                success: function() {
                  console.log('分享成功')
                }
              })
              wx.onMenuShareWeibo({
                title: response.data.productname,
                desc: response.data.summary,
                link: window.location.href,
                imgUrl: response.data.logo,
                success: function() {
                  console.log('分享成功')
                },
                cancel: function(){
                  console.log('分享取消')
                }
              })
            })
          })
        }
      }).catch(error => {
        console.log(error)
        load.clear()
      })
    },
    methods: {
      onChange (index) {
        this.current = index;
      },
      pay () {
        var obj = {
          id: this.product.id,
          num: this.num
        }
        this.$store.commit('saveproduct', obj)
        this.$router.push('/order/pay')
      }
    }
  }
</script>

<style lang="stylus">
  
</style>